import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { breadcrumbs } from '../../../../actions/appActions';
import { reduxForm, formValueSelector } from 'redux-form';
import WhoLookedGrid from '../../components/grids/WhoLookedGrid';
import CroMunicipality from '../../components/generalForm/CroMunicipality';
import CroCountry from '../../components/generalForm/CroCountry';
import CroField from '../../components/generalForm/CroField';
import CroSubhead from '../../components/generalForm/CroSubhead';
import CroLabeledCmp from '../../components/generalForm/CroLabeledCmp';
import Input from '../../../../components/form/Input';
import Button from '../../../../components/form/Button';
import FilesGrid from '../../components/grids/FilesGrid';
import { styles } from '../../index';
import {isPublic} from "../../CroUtils";
import WhoLookedFinancialInstitutionGrid from "../../components/grids/WhoLookedFinancialInstitutionGrid";

const FORM_NAME = 'whoLookedForm';
class WhoLooked extends Component {
  componentWillMount() {
    this.props.breadcrumbs([{ label: 'Kdo na mě nahlížel' }]);
  }

  onRowClick = person => {
    const { change, dispatch } = this.props;
    change('item', person);
    dispatch(push({ pathname: window.location.pathname, query: { q: 'detail' } }));
  };

  goBack = () => {
    this.props.router.goBack();
  };

  render() {
    const {
      location: { query },
      files,
      item,
    } = this.props;

    if (query.q === 'detail' && item) {
      return (
        <div className="whoLookedForm">
          <div className="whoLookedForm__section">
            <CroSubhead title="Žadatel" />
            <div className="whoLookedForm__grid">
              <CroField title="Jméno žadatele" name="item.person.firstName" component={Input} disabled={true} />
              <CroField title="Příjmení žadatele" name="item.person.lastName" component={Input} disabled={true} />
              <CroField title="Datum narození" name="item.person.birthDate" component={Input} disabled={true} />
              <CroField title="Datová schránka" name="item.person.databox" component={Input} disabled={true} />
              <CroField title="E-mail" name="item.person.email" component={Input} disabled={true} />
            </div>
          </div>

          <div className="whoLookedForm__section">
            <CroSubhead title="Adresa trvalého pobytu" />
            <div className="whoLookedForm__grid">
              <CroCountry title="Stát" name="item.person.address" disabled={true} form={FORM_NAME} />
              <CroMunicipality title="Obec" name="item.person.address" disabled={true} form={FORM_NAME} />
              <CroField title="Ulice" name="item.person.address.street" component={Input} disabled={true} />
              <CroField title="Č.p./Č.o." name="item.person.address.orientationNumber" component={Input} disabled={true} />
              <CroField title="PSČ" name="item.person.address.zip" component={Input} disabled={true} />
            </div>
          </div>

          <div className="whoLookedForm__section">
            <CroSubhead title="Doručovací adresa" />
            <div className="whoLookedForm__grid">
              <CroCountry title="Stát" name="item.person.deliveryAddress" disabled={true} form={FORM_NAME} />
              <CroMunicipality title="Obec" name="item.person.deliveryAddress" disabled={true} form={FORM_NAME} />
              <CroField title="Ulice" name="item.person.deliveryAddress.street" component={Input} disabled={true} />
              <CroField title="Č.p./Č.o." name="item.person.deliveryAddress.orientationNumber" component={Input} disabled={true} />
              <CroField title="PSČ" name="item.person.deliveryAddress.zip" component={Input} disabled={true} />
            </div>
          </div>

          {item.legalPerson && (
            <div className="whoLookedForm__section">
              <CroSubhead title="Právnická osoba" />
              <div className="whoLookedForm__grid">
                <CroField title="Název" name="item.legalPerson.name" component={Input} disabled={true} />
                <CroField title="IČO" name="item.legalPerson.identificationNumber" component={Input} disabled={true} />
              </div>
              <CroSubhead title="Sídlo" />
              <div className="whoLookedForm__grid">
                <CroCountry title="Stát" name="item.legalPerson.address" disabled={true} form={FORM_NAME} />
                <CroMunicipality title="Obec" name="item.legalPerson.address" disabled={true} form={FORM_NAME} />
                <CroField title="Ulice" name="item.legalPerson.address.street" component={Input} disabled={true} />
                <CroField title="Č.p./Č.o." name="item.legalPerson.address.orientationNumber" component={Input} disabled={true} />
                <CroField title="PSČ" name="item.legalPerson.address.zip" component={Input} disabled={true} />
              </div>
            </div>
          )}

          {files.length > 0 && (
            <div className="whoLookedForm__section">
              <CroLabeledCmp title="Přílohy">
                <FilesGrid gridName="whoLookedFilesGrid" items={files} />
              </CroLabeledCmp>
            </div>
          )}

          <div className="whoLookedForm__footer">
            <Button type="button" style={styles.buttons} label="Zpět" onClick={this.goBack} />
          </div>
        </div>
      );
    }

    return (<form className="whoLookedForm">

      <WhoLookedGrid gridName="wholookedGrid" filtering={false} url="/funkcionar/api/profil/nahlizeni" sort="created" onRowClick={this.onRowClick} />
      <CroSubhead title="Finanční instituce" />
      <WhoLookedFinancialInstitutionGrid
          gridName="financialHistoryPositionLocalGrid"
          url={`/funkcionar/api/profil/nahlizeni_fin`}
          filtering={false}
          canNotOpen={false}
      />
    </form>);
  }
}

const WhoLookedForm = reduxForm({
  form: FORM_NAME,
})(WhoLooked);

const selector = formValueSelector(FORM_NAME);

export default connect(
  state => ({
    item: selector(state, 'item') || null,
    files: selector(state, 'item.attachments') || [],
  }),
  { breadcrumbs }
)(WhoLookedForm);
